export const ROUTE_ROOT = '/rm';
export const ROUTE_LOBBY = ROUTE_ROOT + '/lobby';
export const ROUTE_GAME = ROUTE_ROOT + '/game';
export const ROUTE_MULTIBET = ROUTE_ROOT + '/multibet';
export const ROUTE_THANKS4PLAY = ROUTE_ROOT + '/thanksForPlaying';
export const ROUTE_RELOAD_LOBBY = ROUTE_ROOT + '/lobbyw';
export const ROUTE_NEW_UI = 'NewUI';
